import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import "@/app/styles/index.scss";
import { UserProvider } from "@/app/providers/UserProvider/ui/UserProvider";
import { App } from "@/app/App";
import * as serviceWorkerRegistration from "@/shared/lib/pwa/serviceWorkerRegistration";

const container = document.getElementById("root");

if (!container) {
    throw new Error(
        "Контейнер root не найден. НЕ удалось вмонтировать реакт приложение",
    );
}
const root = createRoot(container);

root.render(
    <React.StrictMode>
        <BrowserRouter>
            <UserProvider>
                <App />
            </UserProvider>
        </BrowserRouter>
    </React.StrictMode>,
);

// Register service worker for PWA functionality
serviceWorkerRegistration.register({
    onSuccess: () => {
        console.log("Service worker registered successfully");
    },
    onUpdate: (registration) => {
        console.log("New content available, please refresh");
        // Notify user about update
        if (registration.waiting) {
            registration.waiting.postMessage({ type: "SKIP_WAITING" });
        }
    },
});
